import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import * as THREE from 'three';
import View from "../View";
import CameraUtils from "../../Utils/CameraUtils";
import PlanarLayer from "./Planar/PlanarLayer";

var PlanarView =
/*#__PURE__*/
function (_View) {
  _inherits(PlanarView, _View);

  function PlanarView(viewerDiv, extent) {
    var _this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, PlanarView);

    THREE.Object3D.DefaultUp.set(0, 0, 1); // Setup View

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PlanarView).call(this, extent.crs, viewerDiv, options)); // Configure camera

    var dim = extent.dimensions();
    var max = Math.max(dim.x, dim.y);
    var camera3D = _this.camera.camera3D;
    camera3D.near = 0.1;
    camera3D.far = 2 * max;

    _this.camera.camera3D.updateProjectionMatrix();

    var tileLayer = new PlanarLayer('planar', extent, options.object3d, options);

    _this.addLayer(tileLayer);

    var p = {
      coord: extent.center(),
      range: max,
      tilt: 20,
      heading: 0
    };
    CameraUtils.transformCameraToLookAtTarget(_assertThisInitialized(_this), camera3D, p);
    _this.tileLayer = tileLayer;
    return _this;
  }

  _createClass(PlanarView, [{
    key: "addLayer",
    value: function addLayer(layer) {
      return _get(_getPrototypeOf(PlanarView.prototype), "addLayer", this).call(this, layer, this.tileLayer);
    }
  }]);

  return PlanarView;
}(View);

export default PlanarView;